import { EntityMessage } from "../../entity/EntityMessage";

export class DtoMessagesPutRes extends EntityMessage {}
